import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'silos'
const verb = 'get'

export default class OspreySiloMetadata extends BaseAction {
    constructor() {
        const id = '9a5e6964-ef5c-4f32-9391-45266cd2bdff'
        const path = `/${resource}/metadata`
        super(resource, verb, path, id)
        this.noCache = true
    }

    getMetadata(fields) {
        if (!fields) {
            fields = ['base', 'silo']
        }

        if (Array.isArray(fields)) {
            fields = fields.join(',')
        }

        this.params = {
            fields
        }

        return fetchContentIfNeeded(this)
    }
}




// WEBPACK FOOTER //
// src/actions/osprey-api/silos/silos-metadata.js